import { Auth } from 'aws-amplify';
import appConfig from '../../../../config/app-config';

const { address: API_URL, key: API_KEY } = appConfig.apis.billing;

const getHeaders = async () => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    return {
        'x-api-key': API_KEY,
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    };
};

export interface ReceivingBankAccountPayload {
    exibition_name: string;
    alias_name: string;
    bank_name?: string;
}

const parseOrThrow = async (res: Response) => {
    if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.message || `Erro HTTP ${res.status}`);
    }
    return res.json();
};

export interface ReceivingBankAccount {
    id: number;
    receivingBankAccountId: string;
    bankName?: string;
    exibitionName: string;
    aliasName: string;
}

export const listReceivingBankAccounts = async (): Promise<ReceivingBankAccount[]> => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/receiving-bank-accounts?size=200&sort=alias_name`, { headers });
    const data = await parseOrThrow(res);
    return data.list || [];
};

export const createReceivingBankAccount = async (payload: ReceivingBankAccountPayload) => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/receiving-bank-accounts`, {
        method: 'POST', headers, body: JSON.stringify(payload),
    });
    return parseOrThrow(res);
};

export const updateReceivingBankAccount = async (ref: string | number, payload: ReceivingBankAccountPayload) => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/receiving-bank-accounts/${ref}`, {
        method: 'PUT', headers, body: JSON.stringify(payload),
    });
    return parseOrThrow(res);
};

export const deleteReceivingBankAccount = async (ref: string | number) => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/receiving-bank-accounts/${ref}`, { method: 'DELETE', headers });
    return parseOrThrow(res);
};
